/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer without automatic page navigation.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      let drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open !== 'function') {
        try {
          // The markup can exist before its custom element is upgraded.
          // Load its module instead of treating that state as a redirect request.
          await import('@theme/theme-drawer');
          drawer = document.querySelector('theme-drawer#cart-drawer');
        } catch (error) {
          console.warn('[Calvielle] Shopping bag panel unavailable', error);
        }
      }
      if (drawer && typeof drawer.open === 'function') {
        document.getElementById('CalvielleBagFallback')?.remove();
        drawer.open();
        return;
      }
      // Degraded mode: preserve the current page and offer an explicit link.
      // Do not imply add success: this action may also come from the bag icon.
      if (!document.getElementById('CalvielleBagFallback')) {
        const notice = document.createElement('div');
        notice.id = 'CalvielleBagFallback';
        notice.setAttribute('role', 'status');
        notice.className = 'calvielle-bag-fallback';
        notice.append('The shopping bag panel is unavailable. ');
        const link = document.createElement('a');
        link.href = Theme.routes.cart_url || '/cart';
        link.textContent = 'View your shopping bag';
        notice.append(link);
        document.body.append(notice);
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
